module.exports = __webpack_public_path__ + "img/soft_c.75af5442.png";